module.exports = __webpack_public_path__ + "img/young-m1c.63250730.png";